// ============================================
// custom.js
// ============================================

document.addEventListener('DOMContentLoaded', function() {

  // ── 1. スライドショー フェード切り替え ──
  document.querySelectorAll('slideshow-component').forEach(function(slideshow) {
    var slides = slideshow.querySelectorAll('.slideshow__slide');
    if (slides.length < 2) return;

    var track = slideshow.querySelector('.slideshow');
    if (!track) return;

    var slideHeight = slides[0].offsetHeight;

    track.style.position = 'relative';
    track.style.overflow = 'hidden';
    track.style.height = slideHeight + 'px';

    slides.forEach(function(slide, i) {
      slide.style.position = 'absolute';
      slide.style.inset = '0';
      slide.style.width = '100%';
      slide.style.height = '100%';
      slide.style.opacity = i === 0 ? '1' : '0';
      slide.style.transition = 'opacity 1s ease';
      slide.style.zIndex = i === 0 ? '1' : '0';
      slide.style.margin = '0';
    });

    var current = 0;

    var updateDots = function() {
      slideshow.querySelectorAll('.slider-counter__link--dots').forEach(function(dot, i) {
        dot.classList.toggle('slider-counter__link--active', i === current);
        dot.setAttribute('aria-current', i === current ? 'true' : 'false');
      });
    };

    var goTo = function(index) {
      slides[current].style.opacity = '0';
      slides[current].style.zIndex = '0';
      current = (index + slides.length) % slides.length;
      slides[current].style.zIndex = '1';
      slides[current].style.opacity = '1';
      updateDots();
    };

    updateDots();

    slideshow.querySelectorAll('.slider-counter__link--dots').forEach(function(dot, i) {
      dot.addEventListener('click', function(e) {
        e.stopImmediatePropagation();
        e.preventDefault();
        goTo(i);
      }, true);
    });

    var prevBtn = slideshow.querySelector('.slider-button--prev');
    if (prevBtn) {
      prevBtn.addEventListener('click', function(e) {
        e.stopImmediatePropagation();
        goTo(current - 1);
      }, true);
    }

    var nextBtn = slideshow.querySelector('.slider-button--next');
    if (nextBtn) {
      nextBtn.addEventListener('click', function(e) {
        e.stopImmediatePropagation();
        goTo(current + 1);
      }, true);
    }

    var paused = false;
    var autoplayBtn = slideshow.querySelector('.slideshow__autoplay');
    if (autoplayBtn) {
      autoplayBtn.addEventListener('click', function() {
        paused = !paused;
      });
    }

    setInterval(function() {
      if (!paused) goTo(current + 1);
    }, 5000);

    window.addEventListener('resize', function() {
      slides.forEach(function(s) {
        s.style.position = '';
        s.style.opacity = '1';
      });
      track.style.height = '';
      var h = slides[0].offsetHeight;
      track.style.height = h + 'px';
      slides.forEach(function(s, i) {
        s.style.position = 'absolute';
        s.style.inset = '0';
        s.style.width = '100%';
        s.style.height = '100%';
        s.style.opacity = i === current ? '1' : '0';
        s.style.zIndex = i === current ? '1' : '0';
      });
    });
  });

  // ── 2. フェードインアニメーション ──
  var isMobile = window.innerWidth < 750;
  var singleT = isMobile ? 0.05 : 0.15;

  var observer = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: singleT });

  document.querySelectorAll('.fade-group').forEach(function(group) {
    var children = group.querySelectorAll('.fade-up');
    children.forEach(function(child, index) {
      var delay = Math.min(index * 0.15, 1.2);
      child.style.transitionDelay = delay + 's';
    });
  });

  document.querySelectorAll('.fade-up').forEach(function(el) {
    observer.observe(el);
  });

  // ── 3. メガメニュー画像の読み込み検知 ──
  function checkMegaMenuImages() {
    document.querySelectorAll('.mega-panel__card-img img:not(.loaded)').forEach(function(img) {
      if (img.complete && img.naturalWidth > 0) {
        img.classList.add('loaded');
      } else {
        img.addEventListener('load', function() {
          img.classList.add('loaded');
        }, { once: true });
      }
    });
  }

  checkMegaMenuImages();

  document.querySelectorAll('.header__menu-item').forEach(function(item) {
    item.addEventListener('mouseenter', function() {
      setTimeout(checkMegaMenuImages, 50);
    });
  });

// ── 4. FAQ アコーディオン ──
  document.querySelectorAll('.faq-q').forEach(function(q) {
    q.addEventListener('click', function() {
      var item = this.parentElement;
      var isOpen = item.classList.contains('is-open');

      if (isOpen) {
        item.classList.remove('is-open');
      } else {
        item.classList.add('is-open');
      }
    });
  });

  // ★★★ ここから下を追加 ★★★

  // ── 5. ストーリーモーダル ──
  var modalBody = document.body;

  function openStoryModal(modal) {
    if (!modal) return;
    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');
    modalBody.classList.add('is-modal-open');
  }

  function closeStoryModal(modal) {
    if (!modal) return;
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    modalBody.classList.remove('is-modal-open');
  }

  // 開く
  document.querySelectorAll('.story_open').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var id = btn.getAttribute('data-modal');
      openStoryModal(document.getElementById(id));
    });
  });

  // 閉じる（×・オーバーレイ）
  document.querySelectorAll('.story_modal [data-close]').forEach(function(el) {
    el.addEventListener('click', function() {
      closeStoryModal(el.closest('.story_modal'));
    });
  });

  // Escキーで閉じる
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') {
      closeStoryModal(document.querySelector('.story_modal.is-open'));
    }
  });

  // ★★★ ここまで追加 ★★★

});
  // ── 6. GA4 カスタムイベント計測 ──

  // ② LINE申し込みボタンのクリック
  document.querySelectorAll('.line_btn_ara a, a[href*="lin.ee"], a[href*="line.me"]').forEach(function(btn) {
    btn.addEventListener('click', function() {
      if (typeof gtag === 'function') {
        gtag('event', 'line_click', {
          event_category: 'engagement',
          link_url: btn.href
        });
      }
    });
  });

 // ③ ふるさと納税リンクのクリック（最終版：楽天への全リンク対応）
  document.querySelectorAll('.furusato_banner a, a[href*="rakuten.co.jp"]').forEach(function(banner) {
    banner.addEventListener('click', function() {
      if (typeof gtag === 'function') {
        gtag('event', 'furusato_click', {
          event_category: 'engagement',
          link_url: banner.href
        });
      }
    });
  });

  // ① お問い合わせフォームの送信（Powerful Contact Form Builder）
  document.addEventListener('submit', function(e) {
    if (e.target.closest('.globo-formbuilder')) {
      if (typeof gtag === 'function') {
        gtag('event', 'contact_submit', {
          event_category: 'engagement'
        });
      }
    }
  }, true);